<template>
  <div>
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4 mob-hidden"
    />
    <TeamDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />

    <!-- Teams -->
    <div class="lg:mt-0 md:mt-0 mt-20">
      <div class="teamsbg absolute">
        <div class="relative">
          <div class="absolute top-2 -right-10">
            <img
              src="../../../assets/images/bg-des/team-bg-t1.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
          <div class="absolute top25rem left-14">
            <img
              src="../../../assets/images/bg-des/team-bg-t2.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
        </div>
      </div>
      <div class="relative top-16">
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10"
          v-if="board_of_directors.length"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Board Members - Friends of Caregiver Saathi
          </p>
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-8 lg:gap-8 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3 cursor-pointer"
              v-for="(item, index) in board_of_directors"
              :key="'item-' + index"
            >
              <div>
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  @click="toggleDetails(true, item)"
                  class="rounded-full md:h-28 lg:h-28 h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                />
                <div class="flex justify-center items-center gap-2">
                  <p
                    class="team-mbr-name text-center text-black"
                    @click="toggleDetails(true, item)"
                  >
                    <!-- <span class=""> {{ item.dr }}</span> -->
                    <span class="uppercase">{{ item.name }} </span>
                  </p>
                  <a
                    :href="item.linkedIn"
                    v-if="
                      item.hasOwnProperty('linkedIn') && item.linkedIn != ''
                    "
                    target="_blank"
                  >
                    <img
                      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/linkedin.png"
                      class="w-4 h-4 object-contain mb-1"
                    />
                  </a>
                </div>
                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10 pt-20"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Team - Caregiver Saathi
          </p>
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-8 lg:gap-8 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3 cursor-pointer"
              v-for="(item, index) in teams"
              :key="'item-' + index"
            >
              <div @click="toggleDetails(true, item)">
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  class="rounded-full md:h-28 lg:h-28 h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                />
                <p class="team-mbr-name text-center text-black">
                  <!-- <span class=""> {{ item.dr }}</span> -->
                  <span class="uppercase"> {{ item.name }}</span>
                </p>

                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mentors -->
    <div class="mt-40">
      <div class="flex justify-end">
        <div class="mentorsbg absolute">
          <div class="relative">
            <div class="absolute right-16 trans-rotate-31">
              <img
                src="../../../assets/images/bg-des/team-bg-t1.svg"
                alt="bg-polygon"
                class=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="relative">
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Mentors - Caregiver Saathi
          </p>

          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-10 lg:gap-10 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3"
              v-for="(item, index) in mentor"
              :key="'item-' + index"
            >
              <div>
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  class="rounded-full md:h-28 lg:h-28 cursor-pointer h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                  @click="toggleDetails(true, item)"
                />

                <div class="flex justify-center items-center gap-2">
                  <p
                    class="team-mbr-name text-center text-black cursor-pointer"
                    @click="toggleDetails(true, item)"
                  >
                    <!-- <span class=""> {{ item.dr }}</span> -->
                    <span class="uppercase"> {{ item.name }}</span>
                  </p>
                  <a :href="item.linkedIn" v-if="item.linkedIn" target="_blank">
                    <img
                      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/linkedin.png"
                      class="w-4 h-4 object-contain mb-1"
                    />
                  </a>
                </div>
                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Council Advisors -->
    <div class="pt-20 pb-20">
      <div class="teamsbg absolute">
        <div class="relative">
          <div class="absolute top-2 -right-10">
            <img
              src="../../../assets/images/bg-des/team-bg-t1.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
          <div class="absolute top25rem left-14">
            <img
              src="../../../assets/images/bg-des/team-bg-t2.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
        </div>
      </div>
      <div class="relative top-16">
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Council of Advisors - Caregiver Saathi
          </p>

          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-10 lg:gap-10 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3"
              v-for="(item, index) in advisors"
              :key="'item-' + index"
            >
              <div>
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  class="rounded-full md:h-28 lg:h-28 h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                  @click="toggleDetails(true, item)"
                />
                <div class="flex justify-center items-center gap-2">
                  <p
                    class="team-mbr-name text-center text-black"
                    @click="toggleDetails(true, item)"
                  >
                    <!-- <span class=""> {{ item.dr }}</span> -->
                    <span class="uppercase"> {{ item.name }}</span>
                  </p>
                  <a :href="item.linkedIn" v-if="item.linkedIn" target="_blank">
                    <img
                      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/linkedin.png"
                      class="w-4 h-4 object-contain mb-1"
                    />
                  </a>
                </div>
                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TeamDetailsPopup from "./TeamDetailsPopup";
import { mapState } from "vuex";
export default {
  components: {
    TeamDetailsPopup,
  },
  data() {
    return {
      editModal: false,
      isDetailsActive: false,
      selectedTesimonial: {},
      teams: [
        //         {
        //           id: "01",
        //           name: "Bhavana Issar",
        //           designation: "Founder & CEO",
        //           img: require("../../../assets/images/team/Bhavana Issar.jpeg"),
        //           html: `<p class="">Bhavana now the Founder & CEO of a social venture Caregiver Saathi which supports family caregivers as companions for their well-being across a variety of psycho-social needs through coaching, counselling, support groups and training.</p> <p class="pt-4">She is a passionate person with diverse interests. After her corporate stint in HR, she is an Organization consultant in the area of Change, Leadership Development and Organization Building. She is a Fellow and facilitator in Process Work with Sumedhas Academy for Human Context, Gestalt OD Practitioner.</p><p class="pt-4">Her story was included in the book by bestselling author Rashmi Bansal - Touch the Sky: Stories of women across India who are changing their destiny.</p> <p class="pt-4">She is a motorcyclist and believes motorcycling has helped her push the boundaries of the body and mind. She supports women motorcyclists to realize their dreams. </p>`,
        //         },
        //         {
        //           id: "02",
        //           name: "Ashu (Kumud Kalia) Issar",
        //           designation: "Co Founder",
        //           img: require("../../../assets/images/team/Ashu Issar.jpeg"),
        //           html: `<p class="">Ashu Issar, a postgraduate in Botany, married an Indian Air Force Officer in the early 70s. Marriage and two children couldn't dampen her quest for knowledge and learning. Proving the cliché that learning is a lifelong process did her Bachelor's in Education after a gap of seven years and found her mission and passion among adolescents with in the school system for 32 years. 16 years later, she completed a Diploma in Journalism to add professional expertise to her passion for the school publication. 32 years of teaching experience convinced her that a bond founded on trust catalyses learning as well as caring. Four years later she gave another twist to her career and started her journey of process work with Indian Society of Applied Behavioural Science (ISABS). As a professional member of ISABS, she has facilitated many human process labs with corporates, social and education sectors like BHEL, MDI Gurugram, IIHMR Jaipur, EMPI and social organizations like CINNI, Aklavya and Bare Foot Academy. As both of these are helping professions, it has given her deep insights into human behaviour and their emotional needs. A diligent and the primary caregiver of many family members from early adolescent years, she has practical experience of dealing with bed bound terminal patients and their caregivers. The crux of caring for a patient is compassion and patience for the patient, as well as often-neglected caregiver, hence the birth of the Caregiver Saathi™.</p>`,
        //         },
        //         {
        //           id: "03",
        //           name: " Aneesh Issar",
        //           designation: "Director",
        //           img: require("../../../assets/images/team/aneesh.png"),
        //           html: `<p class="">Aneesh provides leadership to a variety of activities with Caregiver Saathi™ to help conceptualize and execute the road-map to scale this venture. He has worked in a number of early and growth stage firms as well as in intrapreneurial roles at larger organizations. His last corporate assignment was at Datamatics, setting up and heading the research and consulting BU, a space he has worked in for over 12 years across a diverse set of responsibilities from operational delivery excellence to driving growth initiatives. Having worked with a variety of companies such as Johnson & Johnson, Adidas, ICICI Lombard and Aranca, he has over 18 years of diverse experience. Passionate about new experiences, he likes travel, meeting new people and procrastinates on writing a book.</p><pclass="pt-4">After completing his Bachelor of Engineering (Mechanical} from Birla Vishwakarma Mahavidyalaya College of Engineering, V.V. Nagar Gujarat, he went on to earn his MBA from IIM, Lucknow. </p>`,
        //         },
        //         {
        //           id: "04",
        //           name: "Gaurav Suri",
        //           img: require("../../../assets/images/team/Gaurav Suri.jpeg"),
        //           html: `<p class="">Gaurav Suri provides leadership to the marketing and communication functions along with BIU & Digital Eco System for the UTI Asset Management Company Ltd. He is a member of the AMFI financial literacy committee and leading communication development on "MF Sahi hai "campaign.
        // </p><p class="pt-4">His previous assignment was as Director Marketing and Product Development, Metlife. Having worked with a variety of companies such as FMCG Majors (Britannia Industries Limited-Danone group and Perfetti Van Melle} and the Insurance industry, he has over 23 years of diverse experience.
        // </p><p class="pt-4">After completing his Bachelor of Engineering (Mechanical} from Regional Engineering College, Bhopal he went on to earn his MBA from XLRI, Jamshedpur. </p></p>`,
        //         },
        //         //         {
        //         //           id: "04",
        //         //           name: "Nabiya Ethiraj",
        //         //           designation: "Project Coordinator - Outreach",
        //         //           img: require("../../../assets/images/team/Nabiya Ethiraj.jpeg"),
        //         //           html: `<p class="">Nabiya has a Masters in Social Work (Criminology & Justice) from the Tata Institute of Social Sciences (Mumbai) and MBA from Madras University.
        //         // She has an extensive experience working in the development, mental health and education sectors including but not limited to working with children & women from tribal populations, rehabilitating ex-Devadasi women, government officials, Dalit SHGs, female and transgender sex workers and their children and tsunami victims </p>`,
        //         //         },
        //         //         {
        //         //           id: "05",
        //         //           name: "Vimala MV",
        //         //           designation: "Program Coordinator, Corporate Outreach",
        //         //           img: require("../../../assets/images/team/Vimala MV.jpeg"),
        //         //           html: `<p class="">Vimala has been a Communications Professional for over 15 years and decided to take the leap of faith and moved to the Mental Health landscape recently. She has completed her MS in Communication from Manipal University, studied to be a Certified Art Therapist and has a Diploma in Integrated Counseling accredited by the Complementary Therapists Accredited Association . She wishes to be a catalyst of positive change in people's lives.</p>`,
        //         //         },
        //         // {
        //         //   id: "09",
        //         //   name: "Sadhna Soni",
        //         //   designation:
        //         //     "Program Coordinator, Social Media Marketing & Outreach ",
        //         //   img: require("../../../assets/images/team/Sadhna Soni.jpeg"),
        //         //   html: `<p class="">Sadhna has been engaged in the field of education and training in different capacities for more than a decade- from a professor and trainer to a school headmistress and more. She has spent an extensive period in mainstream education, and her speciality lies in academic delivery, soft skill training, cross-functional resource management and individual and team performance. She has a double MBA in marketing and advertising and International Business and has more than 15 years of experience with organisations like Times of India, Tolani Institute of Management studies and Army schools. She has also been associated with start-ups such as Book tractor, Integral media and Wings.</p>`,
        //         // },
        //         {
        //           id: "06",
        //           name: "Minakshy Iyer",
        //           designation: "Program Coordinator - Learning Programs",
        //           img: require("../../../assets/images/team/Minakshy Iyer.jpg"),
        //           html: `<p class=""><p>Minakshy holds a Master’s degree in Counselling Psychology. She is an alumnus of the University of Mumbai and Tata Institute of Social Sciences, Mumbai. She has been an investment banker for 7 years before she chose to shift to the mental health arena.</p><p class="pt-4">As a freelance mental health professional, she has been a counsellor with well-known organizations in the social development sector. She believes in advocacy of better mental health by promoting emotional resilience and developing life skills from early childhood.</p><p class="pt-4">Her interests include reading children’s books and practicing yoga.</p></p>`,
        //         },
        //         // {
        //         //   id: "07",
        //         //   name: "Ria Chakravorty",
        //         //   designation: "Program Coordinator - Online content and Communication",
        //         //   img: require("../../../assets/images/team/dona mohapatra.jpeg"),
        //         //   html: `<p class=""><p>Ria is a management postgraduate from Symbiosis International University and has experience in the field of PR and Communications in multiple sectors like FMCG, Hospitality and Education. She also has volunteering experience with Oxfam, UK. A positive attitude, willingness to learn new things and pushing boundaries, keep her going.<br>Apart from being a busy mother, she is a yoga enthusiast, avid reader, loves food and travelling.</p></p>`,
        //         // },
        //         {
        //           id: "07",
        //           name: "Dona Mohapatra",
        //           designation: "Program Coordinator - Online content and Communication",
        //           img: require("../../../assets/images/team/dona mohapatra.jpeg"),
        //           html: `<p class=""><p>Dona is a passionate and creative content writer and social media marketer. In her eight years of experience, she has handled various online marketing projects from start to finish increasing sales and online traffic. She is a knee observer which gives her the edge in her line of work.
        // In her free time, she enjoys reading and making art and craft. Loves traveling and trying new cuisines.</p></p>`,
        //         },
      ],
      mentor: [
        //         {
        //           id: "01",
        //           icon: "LinkedinIcon",
        //           dr: "Dr.",
        //           name: "M. R. Rajagopal",
        //           img: require("../../../assets/images/team/Dr. Rajagopal.jpeg"),
        //           html: `<p class=""><p>Dr Rajagopal is the director of the WHO Collaborating Center at Trivandrum, Kerala for Policy and Training on Access to Pain Relief, and the founder-chairman of "Pallium India".His initiatives to remove regulatory barriers in availability of oral morphine for pain relief have contributed significantly to the recent Amendment of the NDPS Act of India in 2014. His initiative has also contributed to the development of a Government policy on Palliative Care in the state of Kerala in 2008 and Government of India's National Palliative Care Strategy in 2012. </p> <p class="pt-4">In 2014, Human Rights Watch honored him with Alison Des Forges award for "Extraordinary activism in promoting the notion that denial of pain relief is a violation of human rights". In 2017, a documentary film titled "Hippocratic: 18 experiments in gently shaking the world" based on Dr. Rajagopal's contributions to palliative care was released by Moonshine Agency, </p> <p class="pt-4">Australia (<a href="http://hippocraticfilm.com">http://hippocraticfilm.com/</a>). In 2017, he was named one of the 30 most influential leaders in hospice and palliative medicine by American Academy of Hospice and Palliative Medicine (AAHPM). In 2018, Dr Rajagopal was honored with Padma Shri, the third highest civilian award given annually from the Republic of India.</p></p>`,
        //           href: "https://www.linkedin.com/in/m-r-rajagopal-b3664235/",
        //         },
        //         {
        //           id: "02",
        //           icon: "LinkedinIcon",
        //           name: "Prof. Rajiv Sarin ",
        //           img: require("../../../assets/images/team/Dr-Rajiv-Sarin.jpg"),
        //           html: `<p class=""><p>Prof. Rajiv Sarin is the Former Director of Advanced Centre for Treatment Research and Education in Cancer (ACTREC), Tata Memorial Centre, Mumbai.
        // </p><p class="pt-4">He is In-Charge of the Cancer Genetics Unit & Professor of Radiation Oncology at the Tata Memorial Centre. Trained in Clinical Oncology & Radiation Oncology at The Royal Marsden Hospital & Tata Memorial Hospital, he has over 2 decades of experience in Oncology. His research interests include Cancer Genetics, Breast cancer, Technology development & Public health.</p><p class="pt-4">He has about 100 scientific publications pertaining to cancer management, cancer genetics and radiotherapy. He established the first Indian comprehensive Clinical & Laboratory Cancer Genetics services at the Tata Memorial Centre and leads the ICMR Centre of Advanced Research in Cancer Genetics and Genomics at ACTREC.</p><p>He serves as a member of the Ethics and Pathology working groups of the International Cancer Genome Consortium (ICGC). In his capacity as an expert advisor in various committees and task forces of Indian medical and scientific funding bodies like CSIR, ICMR, DBT and in various developing world forums he has contributed towards developing Cancer Control, Cancer Research and low cost technology development programmes in these regions. As the leader of one of the very few Comprehensive Cancer Research Centres in the developing world and as the executive editor of main cancer journal from the developing world - Journal of Cancer Research & Therapeutics (JCRT), he has championed the cause of open access to medical literature and public health issues such as access and cost of cancer care.</p></p>`,
        //           href: "https://www.linkedin.com/in/prof-rajiv-sarin-b153303a/",
        //         },
        //         {
        //           id: "03",
        //           icon: "LinkedinIcon",
        //           dr: "Dr.",
        //           name: "Madhukar Shukla",
        //           img: require("../../../assets/images/team/Dr. Sukla.jpeg"),
        //           html: `<p class="">Dr Madhukar Shukla is Chairperson, Fr Arrupe Centre for Ecology & Sustainability and Professor (Strategic Management & OB) at XLRI Jamshedpur (India), and has keen research and teaching interest in the development sector and social entrepreneurship. He serves on the Board of School of Management & Labour Studies, TISS, and is a member of the Board of Governors of XLRI Jamshedpur. Madhukar is on jury for the oikos Case Competition on Social Entrepreneurship, and is also a Member, Livelihood India Advisory Group. He has been the Conference Coordinator for the National Conference on Social Entrepreneurship since 2009-2017. Madhukar holds a Masters degree in Psychology from Lucknow University and is a PhD from IIT, Kanpur. Prior to Joining XLRI in 1990, he worked with National Productivity Council and Administrative Staff College of India, Hyderabad. He was also a visiting faculty to ESADE, Barcelona during 1993-94.  </p>`,
        //           href: "https://www.linkedin.com/in/madhukarshukla/",
        //         },
        //         {
        //           id: "04",
        //           icon: "LinkedinIcon",
        //           name: "Raghu Ananthanarayanan",
        //           img: require("../../../assets/images/team/Dr. Raghu.jpeg"),
        //           html: `<p class="">Raghu has been enquiring into three questions relentlessly in his life, these are how does one become the best that one can be? How do organizations and groups become the best that they can be? What does it mean to be an Indian? This quest has led to more than a decade of intense study of Yoga with Yogaachaarya T Krishnamaachaarya and Desikachar. During this period he also had the opportunity to interact deeply with J.Krishnamurti and learn Process Work from Prof. Pulin K. Garg. He obtained his Postgraduate Degree in Bio-Medical Engineering from IIT Madras during this time for which he studied the application of Yoga and Praanaayaama in curing back pain. He has published a very well received book "Learning Through Yoga".
        // </p><p class="pt-4">Raghu Ananthanarayanan has co-founded Sumedhas Academy for Human context, The Barefoot Academy for Governance and FLAME TAO Knoware (Pvt. Ltd); He serves on the board of several companies. He is now engaged in mentoring a young group of "sacred activists" called
        // </p><p class="pt-4">Ritambhara, as well as co-creating a platform of Yoga Teachers from the Krishnamacharya Tradition called "Ananta Yoga". He is also associated with YogaVahini, a training and healing centre that specializes in offering Yoga teacher training and therapist training programs.
        // </p>`,
        //           href: "https://www.linkedin.com/in/raghu-ananthanarayanan-64b3045/",
        //         },
        //         {
        //           id: "05",
        //           icon: "LinkedinIcon",
        //           dr: "Dr.",
        //           name: "Roop Gursahani",
        //           img: require("../../../assets/images/team/Dr. Roop.jpeg"),
        //           html: `<p class=""><p>Consultant Neurologist, P. D. Hinduja National Hospital, Mahim & Khar, Mumbai</p><p class="pt-4">Member, Steering Committee,
        // End of Life Care in India (ELICIT) Taskforce
        // Member, Board of Directors, International
        // Neuropalliative Care Society
        // Trustee, Forum for Indian Neurology Education.</p></p>`,
        //           href: "https://www.linkedin.com/in/roop-gursahani-9a719719/",
        //         },
      ],
      advisors: [
        //         // {
        //         //   id: "01",
        //         //   name: "Apoorva Gupta Jalan",
        //         //   img: require("../../../assets/images/team/Apoorva.jpeg"),
        //         //   html: `<p class="">Apoorva Gupta Jalan is the founder of In.Breath, and has been studying and teaching yoga, facilitating healing and personal journeys for individuals for over a decade now. Her journey has been one of tremendous growth and personal transformation, and she has found these practices and philosophies to be an empowering source steering her health, inner growth and evolution. She has trained extensively as a Yoga Acharya and Yoga Vaidya (Therapist) in the tradition of Sri.Krishnamacharya. She is also a Reiki Master and a Breathwork Therapist. In her work, she brings together passion, conviction, and experience, offering the ancient wisdom and tools of Yoga in today's language and context. She is particularly passionate about the power of working with the breath to deal with physical and mental/emotional aspects of our lives.Over the years, Apoorva has done a wide range of work- from taking personalized classes, to taking large group classes in schools, colleges and corporates all over India, to conducting workshops and talks both in India and abroad. As she herself puts it, she is willing to be anywhere to support others in bringing these practices into their lives. </p> `,
        //         // },
        //         //         {
        //         //           id: "02",
        //         //           name: "Gaurav Suri",
        //         //           img: require("../../../assets/images/team/Gaurav Suri.jpeg"),
        //         //           html: `<p class="">Gaurav Suri provides leadership to the marketing and communication functions along with BIU & Digital Eco System for the UTI Asset Management Company Ltd. He is a member of the AMFI financial literacy committee and leading communication development on "MF Sahi hai "campaign.
        //         // </p><p class="pt-4">His previous assignment was as Director Marketing and Product Development, Metlife. Having worked with a variety of companies such as FMCG Majors (Britannia Industries Limited-Danone group and Perfetti Van Melle} and the Insurance industry, he has over 23 years of diverse experience.
        //         // </p><p class="pt-4">After completing his Bachelor of Engineering (Mechanical} from Regional Engineering College, Bhopal he went on to earn his MBA from XLRI, Jamshedpur. </p></p>`,
        //         //         },
        //         {
        //           id: "03",
        //           icon: "LinkedinIcon",
        //           dr: "Dr.",
        //           name: "Khushnuma Mullanfiroze",
        //           img: require("../../../assets/images/Drkhushnuma.png"),
        //           html: `<p class="">"Cure sometimes, relieve often, comfort always!"- a quote by Hippocrates, I really relate to! Even though most of us in the medical profession strive towards this, we often ignore the care-givers of our patients.
        // </p><p class="pt-4">Dr. Khushnuma as a practicing paediatrician initially and now as a Pediatric Hemato-Oncologist, have personally seen and experienced the amount of stress, pressure, anxiety and mental turmoil the parents (and/or care-givers) have about their children afflicted by life-limiting illness.
        // </p><p class="pt-4">Through the platform of Caregiver Saathi™, I hope to touch more lives and ensure good quality of life, not only for the patients directly but also to the caregivers who in most situations get ignored.  </p></p>`,
        //           href: "https://www.linkedin.com/in/khushnuma-mullanfiroze-58b54779/",
        //         },
        //         {
        //           id: "04",
        //           icon: "LinkedinIcon",
        //           name: "Mustafa Moochhala",
        //           img: require("../../../assets/images/team/Mustafa Moochalla.jpeg"),
        //           html: `<p class="">Mustafa has worked in both Corporate and Social sectors for over 30 years. He has worked in social organisations at the field and board levels. He has promoted micro-livelihoods in poor communities. He has promoted poultry farming and organising village level families into clusters and federations and creating viable enterprises owned by them.
        // </p><p class="pt-4">He continues his association with the social sector by being on the Boards of a couple of NGOs and acts as advisor and consultant to a couple more. In industry, he has gained experience as a Trainer and an Organisational Development Consultant. He focuses on HR strategy and policy, structuring and culture building. He has run profit centre operations in India and the UK. He headed businesses in Consulting and Recruitment. He has set up from scratch operations for these units. He has worked in the following organisations so far – Bradma, Modi Xerox, Pradan, Ma Foi and Innobridge.
        // </p><p class="pt-4">He is a fellow of Sumedhas, a society for human context. He has a post-graduate diploma from XLRI, Jamshedpur. </p></p>`,
        //           href: "https://www.linkedin.com/in/mustafa-moochhala-8ba21/",
        //         },
        //         {
        //           id: "05",
        //           name: "Roop Sen",
        //           icon: "LinkedinIcon",
        //           img: require("../../../assets/images/team/Roop Sen.jpeg"),
        //           html: `<p class="">Roop Sen is a researcher and facilitator, who is a founding member of a non profit organisation Sanjog (<a href="www.sanjogindia.org">www.sanjogindia.org</a>), and also consults with organisations and governments (<a href="www.changemantras.in">www.changemantras.in</a>). He specialises in the intersectional space of migration, youth and violence and has worked in India, Bangladesh and Nepal.
        // </p><p class="pt-4">Roop has anchored 9 researches on human trafficking that studied causalities and vulnerabilities, response mechanisms and its effectiveness and systems of criminal justice and social welfare in addressing survivors and the vulnerable populations. He is a member of the Central Advisory Committee on Human Trafficking, and standing committees and the Interministerial Committee that has drafted a new law on human trafficking in India. </p></p> `,
        //           href: "https://www.linkedin.com/in/roop-sen/",
        //         },
        //         {
        //           id: "06",
        //           dr: "Dr.",
        //           name: "Seema Rao",
        //           img: require("../../../assets/images/team/Dr. Seema Rao.jpeg"),
        //           html: `<p class="">Senior Consultant, Department of Palliative Medicine and Supportive Care Kasturba Medical College and Hospital, Manipal ; Full-time Faculty and Consultant, Palliative Care Training Program for Cancer Treatment Centers in India;Honorary Tutor, School of Medicine, Cardiff (UK) ;Member of the Clinical Consultative Committee, PALCARE, Mumbai
        // </p><p class="pt-4">Dr. Seema Rao completed her postgraduate studies in Psychiatry in the year 2001 from Rajiv Gandhi University of Health Sciences, Bangalore. Her work in the field of mental health involved working with the vulnerable and abandoned – the destitute elderly, those with dementia, and chronic mental illnesses in Mumbai. She completed the ‘National Fellowship in Palliative Medicine’ in 2013 and joined Tata Memorial Hospital, Mumbai as a Senior Research Fellow in the Geriatric Palliative Care Project. During her tenure of six years at Tata Memorial Hospital she was responsible for the clinical and administrative functioning of the 13-bedded inpatient respite palliative care facility. Dr. Rao completed her Masters in Palliative Medicine with distinction from Cardiff University, United Kingdom in January 2019.
        // </p><p class="pt-4">She was awarded the Commonwealth Scholarship to pursue her MSc. She is currently working as a Senior Consultant in the ‘Department of Palliative Medicine and Supportive Care’ at Kasturba Medical College and Hospital, Manipal. She is also an Honorary Tutor at School of Medicine, Cardiff University, UK. She is a full-time faculty and consultant with the Palliative Care Training Program for Cancer Treatment Centers in India, which is a collaborative effort of Lien Collaborative for Palliative Care, Asia Pacific Hospice and Palliative Care Network, AIIMS - New Delhi, and Kasturba Medical College and Hospital, Manipal. As a palliative care physician her role encompasses management of physical symptoms in advanced cancer patients, psychosocial care of patients and their caregivers, and end-of-life care. Her special focus of interest is psycho-spiritual care. A physician by profession and a writer by choice, she pens her creative thoughts in her blog <a href="https://randommusings69.wordpress.com">https://randommusings69.wordpress.com </a>
        // </p>`,
        //         },
        //         {
        //           id: "07",
        //           dr: "Dr.",
        //           name: "Rajam Iyer",
        //           icon: "LinkedinIcon",
        //           img: require("../../../assets/images/team/Rajam Iyer.jpeg"),
        //           html: `<p class="">Dr Rajam Iyer is a pulmonologist and palliative care physician with Bhatia and Hinduja Hospitals.She has completed MRCP (UK), DNB, MD and has been a practicing Pulmonologist for 25 years. Her aim is to provide good quality healthcare in a compassionate manner. She believes that educating patients and their families is the key to improving healthcare in India.</p>`,
        //           href: "https://www.linkedin.com/in/rajam-iyer-1a18a9201/",
        //         },
        //         {
        //           id: "08",
        //           name: "KS Narendran",
        //           img: require("../../../assets/images/team/KS Narendran.jpeg"),
        //           html: `<p class="">Narendran is an Organisation Development consultant. He writes from time to time on matters that strike a chord or touch a raw nerve in him.</p>`,
        //         },
      ],
      board_of_directors: [],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    async getAboutUs() {
      // let curPage = this.currentPage - 1;
      let payload = {
        limit: 1000,
        offset: 0,
        sortBy: 1,
      };
      let loader;
      // if (this.search !== "")
      //   Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading();
        const getAboutUs = await this.$store.dispatch(
          "aboutUs/getAboutUs",
          payload
        );
        // console.log(getAuthor);
        loader.close();
        // this.totalRows = this.aboutUs.totalCount;
        let aboutUsData = this.aboutUs.result;
        this.teams = aboutUsData.filter((data) => data.category === "team");
        this.mentor = aboutUsData.filter((data) => data.category === "mentor");
        this.advisors = aboutUsData.filter(
          (data) => data.category === "advisor"
        );
        this.board_of_directors = aboutUsData.filter(
          (data) => data.category === "board members"
        );
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getAboutUs();
  },
  computed: {
    ...mapState("aboutUs", {
      aboutUs: "aboutUs",
    }),
  },
};
</script>
